import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        notifications: [],
        notViewedNotifications: [],
        repositoryName: 'notifications',
    },
    mutations: {
        ...mixinMutations(),
        setNotViewedNotifications(state, notViewedNotifications) {
            state.notViewedNotifications = notViewedNotifications;
        },
    },
    getters: {
        ...mixinGetters(),
        getNotViewedNotifications(state) {
            return state.notViewedNotifications;
        },
    },
    actions: {
        ...mixinActions('notification'),
        listLast(context, params) {
            axios
                .get('/api/notification/list', {
                    params: {
                        requiredDictionaries: params.requiredDictionaries,
                        limit: params.options.itemsPerPage,
                    },
                })
                .then((response) => {
                    context.commit('setList', response.data.rows);
                    context.dispatch('DictionariesModule/setDictionaries', response.data.dictionary, { root: true });
                });
        },
        dismissAll() {
            return axios.get('/api/notification/dismissAll').then((response) => {
                return Promise.resolve(response);
            });
        },
    },
};
